import { Pressable, View, ViewStyle } from "react-native"

import { Image, ImageStyle } from "expo-image"
import { router } from "expo-router"

import { useAppTheme } from "src/hooks/useAppTheme"
import { ThemedStyle } from "src/theme"

interface ImageThumbnailProps {
  imageUrl: string
}

export const ImageThumbnail = ({ imageUrl }: ImageThumbnailProps) => {
  const { themed } = useAppTheme()

  const handleImagePress = () => {
    router.push({ pathname: "/image-viewer", params: { imageUrl } } as any)
  }

  return imageUrl ? (
    <View style={themed($container)}>
      <Pressable
        onPress={handleImagePress}
        style={({ pressed }) => (pressed ? $pressed : undefined)}
      >
        <Image
          source={{
            uri: imageUrl,
          }}
          contentFit="contain"
          style={$image}
          recyclingKey={`image-thumbnail-${imageUrl}`}
        />
      </Pressable>
    </View>
  ) : (
    <></>
  )
}

const $container: ThemedStyle<ViewStyle> = ({ spacing }) => ({
  marginBottom: spacing.sm,
  maxWidth: 300,
})

const $image: ImageStyle = {
  width: "100%",
  height: 180,
}

const $pressed: ViewStyle = {
  opacity: 0.5,
}
